export interface Country {
  code: string;
  name: string;
  flag: string;
  timezones: string[];
}

export const countries: Country[] = [
  {
    code: 'AR',
    name: 'Argentina',
    flag: '🇦🇷',
    timezones: ['America/Argentina/Buenos_Aires', 'America/Argentina/Cordoba', 'America/Argentina/Mendoza']
  },
  {
    code: 'BO',
    name: 'Bolivia',
    flag: '🇧🇴',
    timezones: ['America/La_Paz']
  },
  {
    code: 'BR',
    name: 'Brasil',
    flag: '🇧🇷',
    timezones: ['America/Sao_Paulo', 'America/Rio_Branco', 'America/Manaus']
  },
  {
    code: 'CL',
    name: 'Chile',
    flag: '🇨🇱',
    timezones: ['America/Santiago']
  },
  {
    code: 'CO',
    name: 'Colombia',
    flag: '🇨🇴',
    timezones: ['America/Bogota']
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    flag: '🇨🇷',
    timezones: ['America/Costa_Rica']
  },
  {
    code: 'DO',
    name: 'República Dominicana',
    flag: '🇩🇴',
    timezones: ['America/Santo_Domingo']
  },
  {
    code: 'EC',
    name: 'Ecuador',
    flag: '🇪🇨',
    timezones: ['America/Guayaquil']
  },
  {
    code: 'SV',
    name: 'El Salvador',
    flag: '🇸🇻',
    timezones: ['America/El_Salvador']
  },
  {
    code: 'ES',
    name: 'España',
    flag: '🇪🇸',
    timezones: ['Europe/Madrid', 'Europe/Barcelona']
  },
  {
    code: 'GT',
    name: 'Guatemala',
    flag: '🇬🇹',
    timezones: ['America/Guatemala']
  },
  {
    code: 'IT',
    name: 'Italia',
    flag: '🇮🇹',
    timezones: ['Europe/Rome']
  },
  {
    code: 'MX',
    name: 'México',
    flag: '🇲🇽',
    timezones: ['America/Mexico_City', 'America/Cancun', 'America/Merida', 'America/Monterrey']
  },
  {
    code: 'PE',
    name: 'Perú',
    flag: '🇵🇪',
    timezones: ['America/Lima']
  },
  {
    code: 'VE',
    name: 'Venezuela',
    flag: '🇻🇪',
    timezones: ['America/Caracas']
  },
  {
    code: 'UY',
    name: 'Uruguay',
    flag: '🇺🇾',
    timezones: ['America/Montevideo']
  },
  {
    code: 'PY',
    name: 'Paraguay',
    flag: '🇵🇾',
    timezones: ['America/Asuncion']
  },
  {
    code: 'PA',
    name: 'Panamá',
    flag: '🇵🇦',
    timezones: ['America/Panama']
  },
  {
    code: 'US',
    name: 'Estados Unidos',
    flag: '🇺🇸',
    timezones: ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles']
  },
  {
    code: 'CA',
    name: 'Canadá',
    flag: '🇨🇦',
    timezones: ['America/Toronto', 'America/Vancouver', 'America/Montreal']
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    flag: '🇵🇷',
    timezones: ['America/Puerto_Rico']
  }
];

export const getTimezonesForCountry = (countryCode: string): string[] => {
  const country = countries.find(c => c.code === countryCode);
  return country ? country.timezones : [];
};

export const formatTimezone = (timezone: string): string => {
  return timezone.replace('_', ' ').replace('/', ' - ');
};
